import { GameChrome } from "./app/GameChrome.js";
import { GameProvider } from "./app/GameProvider.js";
import { AnalyticsScreen } from "./features/analytics/AnalyticsScreen.js";
import { CardCatalogScreen } from "./features/cardCatalog/CardCatalogScreen.js";
import { HappeningLab } from "./features/case/HappeningLab.js";
import { ProgressFxLab } from "./features/case/ProgressFxLab.js";
import { SoundCatalogScreen } from "./features/seCatalog/SoundCatalogScreen.js";
import { StageMakerApp } from "./features/stageMaker/StageMakerApp.js";

export function App() {
  if (window.location.pathname === "/card-catalog") return <CardCatalogScreen />;
  if (window.location.pathname === "/se-catalog") return <SoundCatalogScreen />;
  if (window.location.pathname === "/analytics") return <AnalyticsScreen />;
  if (window.location.pathname === "/__progress-fx") return <ProgressFxLab />;
  if (window.location.pathname === "/__happening-lab") return <HappeningLab />;
  if (window.location.pathname.startsWith("/stage-maker")) return <StageMakerApp />;
  return (
    <GameProvider>
      <GameChrome />
    </GameProvider>
  );
}
